import { toast } from "sonner";
import { VIP_ITEM_PRICES } from "@/data/vipItemPrices";
import { getLang } from "@/i18n/I18nProvider";

const NUMBER_LOCALES = { pt: "pt-BR", en: "en-US" };

/** Locale numérico do idioma atual (preços continuam em R$). */
export function simulatorNumberLocale(lang = getLang()) {
    return NUMBER_LOCALES[lang] || "pt-BR";
}

/** Quantidade inteira formatada no idioma atual. */
export function formatQty(value, lang) {
    return Number(value).toLocaleString(simulatorNumberLocale(lang), { maximumFractionDigits: 0 });
}

/** Quantidade compacta para o canto do slot (ex.: 1,5k / 1.5k). */
export function formatSlotQuantity(quantity, lang = getLang()) {
    const n = Number(quantity) || 1;
    if (n >= 1000) {
        const compact = n / 1000;
        const txt = Number.isInteger(compact) ? String(compact) : compact.toFixed(1);
        return `${lang === "pt" ? txt.replace(".", ",") : txt}k`;
    }
    return n.toLocaleString(simulatorNumberLocale(lang));
}

/** Mostra toast do simulador (fora de updaters de setState para evitar duplicar no Strict Mode). */
export function emitSimulatorToast(feedback) {
    if (!feedback) return;
    const opts = feedback.id ? { id: feedback.id } : {};
    if (feedback.type === "success") toast.success(feedback.message, opts);
    else if (feedback.type === "error") toast.error(feedback.message, opts);
    else if (feedback.type === "warning") toast.warning(feedback.message, opts);
}

export function roundMoney4(n) {
    return Math.round(Number(n) * 10000) / 10000;
}

export function formatBRL(value, lang) {
    return Number(value).toLocaleString(simulatorNumberLocale(lang), {
        style: "currency",
        currency: "BRL",
    });
}

export function formatUnitBRL(value, lang) {
    return Number(value).toLocaleString(simulatorNumberLocale(lang), {
        style: "currency",
        currency: "BRL",
        minimumFractionDigits: 2,
        maximumFractionDigits: 6,
    });
}

export function unitPriceForKey(priceKey) {
    if (!priceKey || !VIP_ITEM_PRICES) return 0;
    const v = VIP_ITEM_PRICES[priceKey];
    return typeof v === "number" ? v : 0;
}

export function lineSubtotal(unit, qty) {
    return roundMoney4(unit * qty);
}

export function placementId(id) {
    return `pl-${id}`;
}

export function parsePlacementDragId(dragId) {
    if (typeof dragId !== "string" || !dragId.startsWith("pl-")) return null;
    return dragId.slice(3);
}
